import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import Packages from "@/components/Packages";
import Portfolio from "@/components/Portfolio";
import BookingForm from "@/components/BookingForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Packages />
        <Portfolio />
        <BookingForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
